export default __webpack_public_path__ + "static/media/BirdLeg.7b173c05.png";